import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LayoutIcon, SettingsIcon, SmartphoneIcon } from 'lucide-react';
import { PageCTA } from '../components/PageCTA';
const services = [{
  number: '01',
  icon: LayoutIcon,
  title: 'Web que sitúa tu valor en primer plano',
  description: 'Construimos una experiencia editorial y comercial para que quien llega entienda tu negocio, sus servicios y el siguiente paso sin perderse.',
  includes: ['Arquitectura de contenidos', 'Diseño responsive', 'Páginas clave para conversión'],
  visual: ['Propuesta clara', 'Servicios ordenados', 'Contacto visible']
}, {
  number: '02',
  icon: SmartphoneIcon,
  title: 'Carta digital que facilita elegir',
  description: 'Una carta o catálogo móvil que reúne lo importante en un formato claro, visual y más sencillo de actualizar que un documento estático.',
  includes: ['Experiencia mobile-first', 'Categorías y productos', 'Acceso mediante QR'],
  visual: ['Consulta desde móvil', 'Información actualizable', 'Lectura sin fricción']
}, {
  number: '03',
  icon: SettingsIcon,
  title: 'Gestión para que publicar no sea el final',
  description: 'La entrega incluye una base que se puede cuidar. Acompañamos los cambios necesarios para mantener tu presencia útil y coherente.',
  includes: ['Actualizaciones de contenido', 'Mantenimiento técnico', 'Soporte continuo'],
  visual: ['Base mantenida', 'Cambios acompañados', 'Sin cuotas ocultas']
}];
export function ServicesPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] pt-20 sm:pt-24" data-id="element-548" data-mp="32im7bsl7b4y6">
      <section className="page-header" data-id="element-549" data-mp="2w5pkwbm7pb4">
        <div className="container mx-auto max-w-6xl px-6 md:px-12" data-id="element-550" data-mp="2wxdrm2vukrd">
          <motion.div initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.26,
          ease: [0.23, 1, 0.32, 1]
        }} className="max-w-3xl" data-id="element-551" data-mp="3u98uz7u1j6gt">
            <p className="eyebrow" data-id="element-552" data-mp="1il3zpn4wzh56">Servicios</p>
            <h1 className="mt-5 text-4xl font-medium tracking-[-0.055em] text-white sm:text-6xl" data-id="element-553" data-mp="1nkzseq85vm5f">
              Una presencia digital que trabaja como un todo.
            </h1>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-neutral-300 sm:text-lg" data-id="element-554" data-mp="1el378ykzd5f4">
              No acumulamos entregables aislados. Cada pieza se construye para
              reforzar la misma experiencia: explicar mejor tu valor y hacer más
              simple el siguiente paso.
            </p>
          </motion.div>
        </div>
      </section>

      {services.map((service, index) => {
      const Icon = service.icon;
      return <section key={service.number} className="border-b border-white/10 py-16 sm:py-24" aria-labelledby={`service-${service.number}`} data-id="element-555" data-mp="2yz3xargaeup9" data-mpi={index}>
            <div className="container mx-auto max-w-6xl px-6 md:px-12" data-id="element-556" data-mp="igcmcre1qqnq">
              <div className={`grid gap-10 lg:grid-cols-2 lg:gap-16 ${index % 2 === 1 ? 'lg:[&>div:first-child]:order-2' : ''}`} data-id="element-557" data-mp="x4pne2rzqzp3">
                <motion.div initial={{
              opacity: 0,
              y: 16
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              amount: 0.12
            }} transition={{
              duration: 0.28,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-558" data-mp="164ccpq7g4f1s">
                  <div className="flex items-center gap-4" data-id="element-559" data-mp="3cvbswj5olt40">
                    <span className="meta-number" data-id="element-560" data-mp="3cwwn27o33a1c">{service.number}</span>
                    <span className="h-px w-10 bg-white/25" data-id="element-561" data-mp="3ebfw3rgliz3w" />
                  </div>
                  <div className="mt-9 flex h-12 w-12 items-center justify-center border border-white/15 text-white" data-id="element-562" data-mp="3ja0v5nk43cqr">
                    <Icon size={22} aria-hidden="true" data-id="element-563" data-mp="3oaoqglfdifqs" />
                  </div>
                  <h2 id={`service-${service.number}`} className="mt-7 text-3xl font-medium tracking-[-0.04em] text-white sm:text-4xl" data-id="element-564" data-mp="3t86vi0q9sati">
                    {service.title}
                  </h2>
                  <p className="mt-5 max-w-xl text-sm leading-relaxed text-neutral-300 sm:text-base" data-id="element-565" data-mp="35jns9zm2uo8a">
                    {service.description}
                  </p>
                  <ul className="mt-8 space-y-3 border-t border-white/10 pt-6" data-id="element-566" data-mp="3aboz360h7mqx">
                    {service.includes.map(item => <li key={item} className="flex items-center gap-3 text-sm text-neutral-300" data-id="element-567" data-mp="2hu332yzbyuqk">
                        <CheckIcon size={15} className="text-white" aria-hidden="true" data-id="element-568" data-mp="ywum50hm8m4q" />
                        {item}
                      </li>)}
                  </ul>
                </motion.div>
                <motion.div initial={{
              opacity: 0,
              y: 16
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              amount: 0.12
            }} transition={{
              duration: 0.28,
              delay: 0.06,
              ease: [0.23, 1, 0.32, 1]
            }} className="flex items-start border border-white/10 bg-black p-7 sm:p-9" data-id="element-569" data-mp="g02tw1k3iwoj">
                  <div className="w-full" data-id="element-570" data-mp="3er8tyzhlpuao">
                    <p className="meta-label" data-id="element-571" data-mp="3eumzgglkajmc">Qué se resuelve</p>
                    <h3 className="mt-4 text-lg font-medium tracking-[-0.02em] text-white" data-id="element-572" data-mp="3js6cjd6iwqcp">
                      Los tres puntos que guían esta pieza
                    </h3>
                    <ul className="mt-7 border-t border-white/10" data-id="element-573" data-mp="39sfitdpsefdo">
                      {service.visual.map(item => <li key={item} className="flex items-baseline gap-4 border-b border-white/10 py-4" data-id="element-574" data-mp="1ep38dy5chg4">
                          <CheckIcon size={15} className="shrink-0 translate-y-0.5 text-white" aria-hidden="true" data-id="element-575" data-mp="3opezdr2m9ika" />
                          <span className="text-sm leading-relaxed text-neutral-200" data-id="element-576" data-mp="kaylzejztw6g">
                            {item}
                          </span>
                        </li>)}
                    </ul>
                    <p className="mt-6 max-w-sm text-xs leading-relaxed text-neutral-400" data-id="element-577" data-mp="24uaftaile6pc">
                      La dirección final se adapta a las necesidades, tono y
                      materiales de cada negocio.
                    </p>
                  </div>
                </motion.div>
              </div>
            </div>
          </section>;
    })}
      <PageCTA data-id="element-578" data-mp="1qv1a54s0iuzm" />
    </div>;
}